export const messages = [
    {
        department: "Human Resources",
        initial: "HR",
        title: "Leave Request Approval Question",
        priority: "pending",
        status: "medium",
        time: "09:15 AM",
        date: "2025-10-28",
        messagePreview: "Hi, I submitted a leave request last week but haven't received a response yet...",
        fullMessage: `Hi Human Resources Team,

I submitted a leave request for November 15-17 last week (Reference: LR-2025-1023) but haven't received a response yet. Could you please check the status?

Thank you!`,
    },
    {
        department: "Payroll Services",
        initial: "PS",
        title: "Tax Withholding Adjustment",
        priority: "responded",
        status: "low",
        time: "02:30 PM",
        date: "2025-10-27",
        messagePreview: "I would like to adjust my tax withholding for 2026. What documents do I need to provide?",
        fullMessage: `Hi Payroll Services,

Thank you for reaching out! To adjust your tax withholding for 2026, please complete the W-4 form available in the Employee Documents portal. The deadline for submission is December 15, 2025.

If you need assistance completing the form, please let us know.

Best regards`,
        response: {
            time: "04:15 PM",
            date: "2025-10-27",
            message: `Hi Dillon,

I would like to adjust my tax withholding for 2026. What documents do I need to provide and what is the deadline for submitting the changes?

Best regards
Payroll Services Team`,
        },
        reply: {
            message: "Thank you for the quick response! I found the W-4 form in the portal. Just to confirm - can I submit it electronically through the portal or do I need to print and sign it?",
            date: "2025-10-28",
            time: "09:30 AM"
        }
    },
    {
        department: "IT Support",
        initial: "IT",
        title: "Tax Withholding Adjustment",
        priority: "resolved",
        status: "high",
        time: "02:30 PM",
        date: "2025-10-27",
        messagePreview: "I'm unable to connect to the company VPN from my laptop...",
        fullMessage: `Hi IT Support,

I'm unable to connect to the company VPN from my laptop. I keep getting an "Authentication Failed" error. I've already tried resetting my password.

Can you help?

Thanks`,
            
        response: {
            time: "11:45 AM",
            date: "2025-10-25",
            message: `Hi Dillon,

We've reset your VPN credentials on our end. Please use the temporary password we sent to your email and change it upon first login.

The issue has been resolved. Let us know if you continue to experience problems.

Best regards
IT Support Team`,
        },
    },
    {
        department: "Training & Development",
        initial: "TD",
        title: "Tax Withholding Adjustment",
        priority: "responded",
        status: "low",
        time: "02:30 PM",
        date: "2025-10-27",
        messagePreview: "I'm unable to connect to the company VPN from my laptop...",
        fullMessage: `Hi IT Support,

I'm unable to connect to the company VPN from my laptop. I keep getting an "Authentication Failed" error. I've already tried resetting my password.

Can you help?

Thanks`,
            
        response: {
            time: "05:20 PM",
            date: "2025-10-24",
            message: `Hi Dillon,

Great to hear you're interested! The Advanced React Patterns course has one prerequisite: React Fundamentals (which you've already completed).

Yes, this 12-hour course will count towards your professional development hours. We've enrolled you in the November cohort.

You'll receive course materials by email next week.

Best regards
Training & Development Team`,
        },
    }
];